"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = cheapRecreate;

// makes cheap array recreation (with no trackBy, with no events, with no item mediator etc)
function cheapRecreate(self) {
  var newItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var newLength = newItems.length;
  var oldLength = self.length;
  var lengthDiff = newLength - oldLength;

  for (var i = 0; i < newLength; i++) {
    self[i] = newItems[i];
  }

  for (var _i = 0; _i < lengthDiff; _i++) {
    delete self[_i + newLength];
  }

  self.length = newLength;
  return self;
}
//# sourceMappingURL=_cheaprecreate.js.map